<div class="statistics-cards-grid">
  @for (card of cards; track card.label) {
    <card-stats [card]="card"></card-stats>
  }
</div>
